export default {
  "main": {
    "login": "Log in",
    "email": "Email",
    "password": "Password",
    "loginButton": "Log in",
    "developedBy": "Developed by",
    "error": "The user or password is incorrect",
    "sessionExpired": "Your session has automatically been closed, please log your credentials in again to access.",
    "sessionExpiredTitle": "Expired session",
    "next": "Next",
    "emailRequired": "Email is required",
    "passwordRequired": "Password is required",
    "validating": "Validating ...",
    "back": "Back",
    "loading": "Loading",
    "errorGetUrlSSO": "Could not get url from Auth0 to login. Contact the Gauss Control Help Desk.",
    "errorLoginlSSO": "Could not login with Auth0 authentication. Please try again and if the problem persists, contact the Gauss Control help desk.",
    "backToLogin": "Back to login",
    "redirectTitleError": "Page not available",
    "redirectMessageError": "The redirection of the consulted url could not be performed"
  }
};


// WEBPACK FOOTER //
// ./source/client/components/locales/language_configuration/english/login/index.js